'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PassRecoveryStepOneView: {
        displayName: 'PassRecoveryStepOneView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/PassRecovery/PassRecoveryStepOne/default/PassRecoveryStepOneView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PassRecoveryStepOneView = _wrapComponent('PassRecoveryStepOneView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(PassRecoveryStepOneView, _Component);

    function PassRecoveryStepOneView(props) {
        (0, _classCallCheck3.default)(this, PassRecoveryStepOneView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepOneView.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepOneView)).call(this, props));

        _this.onClickRegistration = function (event) {
            event.preventDefault();
            if (_this.props.onClickRegistration) {
                _this.props.onClickRegistration(event);
            }
        };

        _this.handlePhoneChange = function (phone, country) {
            _this.props.changeFieldLogin(phone);
        };

        _this.showError = function () {
            var _this$props = _this.props,
                error = _this$props.error,
                errorCode = _this$props.errorCode,
                lang = _this$props.lang;

            if (error) {
                if (errorCode === null || errorCode === undefined) {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang['store.common.server_is_unavailable']
                    );
                } else {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang[error]
                    );
                }
            }

            return '';
        };

        return _this;
    }

    (0, _createClass3.default)(PassRecoveryStepOneView, [{
        key: 'render',
        value: function render() {
            var lang = this.props.lang;


            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                this.showError(),
                _react3.default.createElement(
                    'main',
                    { id: 'authentication' },
                    _react3.default.createElement(
                        'div',
                        { className: 'container__' },
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-md-12' },
                                _react3.default.createElement(
                                    'section',
                                    { id: 'auth-form', className: 'sign-in' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'bordered' },
                                        _react3.default.createElement(
                                            'form',
                                            { role: 'form', className: 'login-form', onSubmit: this.props.onSubmit },
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                { controlId: 'formLogin' },
                                                _react3.default.createElement(
                                                    _reactBootstrap.ControlLabel,
                                                    null,
                                                    lang['store.login.phone_or_email']
                                                ),
                                                _react3.default.createElement(_components2.PhoneEmailInput, {
                                                    autoComplete: 'username',
                                                    value: this.props.login,
                                                    initialValue: '',
                                                    defaultCountry: '',
                                                    flagsImagePath: '/assets/images/flags.png',
                                                    onChange: this.handlePhoneChange,
                                                    classNames: 'super_telephone_input',
                                                    placeholder: lang['store.login.email_or_phone_placeholder']
                                                })
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                null,
                                                _react3.default.createElement(
                                                    _reactBootstrap.Button,
                                                    {
                                                        type: 'submit',
                                                        bsStyle: 'primary',
                                                        className: 'form-control',
                                                        disabled: this.props.disabledSubmit
                                                    },
                                                    lang['store.password_recovery.send_code']
                                                )
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                null,
                                                _react3.default.createElement(
                                                    'div',
                                                    { className: 'text-center to-page-registration' },
                                                    _react3.default.createElement(
                                                        _reactRouter.Link,
                                                        { to: '/registration', onClick: this.onClickRegistration },
                                                        lang['store.common.sign_up']
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return PassRecoveryStepOneView;
}(_react2.Component), _class.propTypes = {
    onSend: _react2.PropTypes.func,
    lang: _react2.PropTypes.object
}, _class.contextTypes = {}, _temp));

exports.default = PassRecoveryStepOneView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecoveryStepOne/default/PassRecoveryStepOneView.jsx
// module id = 1721
// module chunks = 0